/* eslint-disable */
export const Terms = () => (
  <div className="container-content">
    <p>
      THE TERMS OF SERVICE SET FORTH BELOW (THESE “TERMS”) GOVERN YOUR USE OF CHECK POINT’S SERVICES (AS DEFINED BELOW)
      AND ARE A LEGAL AGREEMENT BETWEEN THE INDIVIDUAL USING THE SERVICES AND ANY LEGAL ENTITY ON WHOSE BEHALF SUCH
      INDIVIDUAL IS ACTING (“YOU” OR “YOUR”) AND CHECK POINT SOFTWARE TECHNOLOGIES LTD. (“CHECK POINT”). PLEASE READ
      THESE TERMS CAREFULLY BEFORE USING THE SERVICES.
    </p>
    <p>
      BY YOUR USE OF SERVICE PROVIDED OR YOUR CLICKING TO ACCEPT OR AGREE THESE TERMS, YOU AGREE TO BE BOUND BY THESE
      TERMS. IF YOU DO NOT AGREE WITH ANY OF THESE TERMS, DO NOT ACCESS OR OTHERWISE USE ANY INFORMATION CONTAINED IN
      THE SERVICE. YOUR CONTINUED USE OF SERVICE PROVIDED SHALL BE DEEMED TO BE YOUR CONTINUED AGREEMENT TO ABIDE BY
      EACH OF THE TERMS SET FORTH BELOW.
    </p>
    <p>
      <strong>1. SERVICES</strong>
    </p>
    <p>
      “Services” shall mean: (i) the products and services in the Check Point CloudGuard, Harmony, Infinity Platform
      Services, Cyberint and Perimeter 81 families and brands; (ii) Check Point Quantum Smart-1 and Quantum Spark
      Management Application; (iii) any cloud or SaaS products and services available through Check Point’s Infinity
      Portal; and (iv) any other Check Point products and services provided to You in association with these Terms,
      including any management, dashboard and/or ancillary tool or service provided by Check Point in connection with
      the Services, except for any hardware. Check Point may update the list of Services from time to time.
    </p>
    <p>
      <strong>2. RIGHT TO USE AND RESTRICTIONS</strong>
    </p>
    <p>
      2.1&nbsp;<u>Right to Use the Services</u>. If You purchased a valid subscription license to a Service, subject to
      these Terms and the terms specified in Your order for Services (including from a Check Point authorized reseller
      or distributor), as approved by Check Point, at its sole discretion (“Service Order”), and payment of the
      applicable fees, Check Point hereby grants only to You, a non-exclusive, non-sublicensable, non-transferable
      license for the service term specified in your Service Order (“Service Term”) to access and use the Services in
      accordance with the relevant documentation provided by Check Point. Except as otherwise specified herein or as
      agreed in writing, during the Service Term, the subscription license and payment of the applicable fees shall be
      non-cancellable and non-refundable.
    </p>
    <p>
      2.2&nbsp;<u>Restrictions</u>.
    </p>
    <p>
      2.2.1 You may use the Services only as described in Your Service Order and the Service description in Check
      Point’s product catalogue and the accompanying documentation and subject to the permitted scope and fair usage as
      to be defined by Check Point from time to time, including, without limitation, maximum authorized users,
      applications, devices, gateways, cores, virtual machines (VMs), assets, data traffic, bandwidth, throughput, logs
      and Service capacity (collectively, “Permitted Scope”). Check Point may use technical tools to measure Your
      Service consumption and verify Your compliance with the Permitted Scope and these Terms.
    </p>
    <p>
      Without derogating from the above, with respect to each of the Harmony Connect Remote Access and the Harmony
      Connect Internet Access Services, the Permitted Scope per licensed unit covers a maximum of 12GB of traffic sent
      through the Harmony Connect cloud per month during the applicable subscription term.
    </p>
    <p>
      2.2.2 You may not copy the Services, the underlying technology and any documentation provided in connection
      therewith, in whole or in part (collectively, “Technology”). You agree not to allow others to use the Services and
      You will not use the Services for the benefit of third parties. You acknowledge that the source code underlying
      the Technology, and any other underlying ideas or concepts, are valuable intellectual property of Check Point and
      You agree not to attempt to (or permit others to) decipher, reverse translate, decompile, disassemble or otherwise
      reverse engineer or attempt to reconstruct or discover any source code or underlying ideas or algorithms or file
      formats or programming or interoperability interfaces of any portion of the Technology by any means whatsoever.
      You will not develop methods to enable unauthorized parties to use the Technology, or to develop any other product
      and/or service containing any of the concepts and ideas contained in the Technology not independently developed by
      You. You will not (and will not direct any third party to) modify the Technology or incorporate any portion of the
      Technology into any software and/or service or create a derivative work of any portion of the Technology. You
      shall not use the Services to conduct any activity which is fraudulent and/or which violates any applicable law or
      regulation, infringes rights of any party or breaches these Terms and the terms of use of any third party SaaS
      (software as-a-service) application linked or connected to the Service (“Third Party Application”). No Service,
      nor any portion thereof, may be used by or on behalf of, accessed by, re-sold to, rented to, or distributed to any
      other party.
    </p>
    <p>
      2.3 <u>Managed Service Provider</u>. Notwithstanding Section 2.2 of these Terms, if it is indicated in Your
      Service Order that You provide the Services to Your customers as a managed service provider or if you are a party
      to a managed service provider agreement with Check Point (including via an authorized Check Point distributor)
      (“Managed Service Provider”), the Services are licensed to You only for the operations of Your customers. You are
      responsible for (i) the compliance with these Terms by Your customers (ii) obtaining the consent of each of Your
      customers to these Terms as a condition to use by each such customer of the Service; and (iii) maintaining an
      evidence of such consent.
    </p>
    <p>
      2.4 <u>Trial or Evaluation License</u>. If You use the Services for an initial trial or evaluation period, the
      right to use the Services is valid only for the designated period determined by Check Point, at its sole
      discretion, and is designed to allow You to evaluate the Services during such period. Check Point may, in its sole
      discretion, at any time prior to or during such period, discontinue provision of the Services and terminate the
      right to use the Services with immediate effect. Upon expiration or termination of such period, Your rights under
      these Terms with respect to such terminated or expired Services shall terminate.
    </p>
    <p>
      2.5 <u>Third Party Applications</u>. Certain Services are linked and connected to Third Party Applications. You
      agree that Check Point has no control over the Third Party Applications nor the content or information posted
      therein. Check Point shall have no responsibility or liability whatsoever in connection with any Third Party
      Application. Third Party Applications may have terms of use and privacy policies that are different from those
      herein. You are responsible to review such terms and policies at the third parties’ websites’ respective privacy
      notices and terms of service.
    </p>
    <p>
      2.6 <u>Excess Usage</u>. Without derogating from Section 2.2 above and from any other remedy available to Check
      Point, if Your usage of the Services exceeds the Permitted Scope, Check Point shall be entitled to: (i) charge You
      per its list price, as amended from time to time (including through its authorized resellers and distributors),
      for such additional Service subscription licenses as required to cover the excess usage; and (ii) upon notice,
      limit, suspend or terminate Your license to use the Service.
    </p>
    <p>
      <strong>3. MAINTENANCE AND SUPPORT</strong>
    </p>
    <p>
      3.1 <u>Support Terms</u>. Subject to Your purchase of support and maintenance as described in Your Service Order
      and to payment of the applicable fees, You shall be provided with support and maintenance per the applicable
      service level indicated in your Service Order and for the covered Services thereto (the “Support Services”) The
      purchase of Support Services shall be governed by the terms of the applicable support program and service level
      agreement available at{' '}
      <a href="https://www.checkpoint.com/support-services/support-plans/" target="_blank">
        www.checkpoint.com/support-services/support-plans/
      </a>{' '}
      or at any successor webpage. Unless otherwise stated in Your Service Order or Your agreement with Check Point, the
      purchasing of a valid subscription license to a Service does not cover the payment for the corresponding Support
      Service.
    </p>
    <p>
      3.2 <u>Collaborative Support</u>.&nbsp;If You purchase Support Service per one of Check Point’s Collaborative
      Support Programs, Check Point shall not be responsible for the actions or omissions of Your support partner.
    </p>
    <p>
      <strong>4. SERVICE LEVEL</strong>
    </p>
    <p>
      4.1 <u>Service Availability</u>. Check Point will use commercial reasonable efforts that each of the Services
      listed in the table below (except for Beta Service, as defined below) will be available for such time of each
      calendar month, as specified opposite to the name of such Service (“Monthly Service Availability”).
    </p>
    <table className="table table-striped">
      <tbody>
        <tr>
          <td width="424">
            <strong>Services</strong>
          </td>
          <td width="132">
            <strong>Monthly Service Availability</strong>
          </td>
        </tr>
        <tr>
          <td width="424">Harmony Connect, Harmony SASE*, Perimeter 81*</td>
          <td width="132">99.999%</td>
        </tr>
        <tr>
          <td width="424">
            Infinity Portal, Infinity XDR/XPR, Infinity Events, Quantum Smart-1 Cloud, Harmony Email &amp;
            Collaboration, CloudGuard CNAPP, CloudGuard WAF, Quantum Spark Management Application, Cyberint solutions,
            Infinity Platform ERM (External Risk Management)
          </td>
          <td width="132">99.9%</td>
        </tr>
      </tbody>
    </table>
    <p>
      <small>
        *Under the following configuration: (i) deploy network in at least two availability zones within the same
        region; (ii) set up two gateways per availability zone; (iii) connect tunnels to gateways on 2 different
        regions; (iv) whitelist all gateways’ IP addresses if you are deploying through gateways instead of using
        tunnels.
      </small>
    </p>
    <p>The Monthly Service Availability shall be calculated as follows:</p>
    <p>Monthly Service Availability (%) = A / B x 100</p>
    <ul>
      <li>
        A = total number of minutes in the relevant calendar month, excluding any Outage Minutes (as defined below).
      </li>
      <li>B = total number of minutes in the relevant calendar month.</li>
    </ul>
    <p>
      “Outage Minutes” shall mean minutes in which the applicable Service is completely unavailable and inactive while
      Your systems and internet connection are working properly, other than unavailability due to: (ii) Your acts,
      omissions or requests; (ii) Service adjustments performed per Your request; (iii) error or malfunction of an
      ancillary tool of the Service which is deployed and/or managed by You, including, without limitation, the
      Service’s application connector; (iv)&nbsp;an event beyond the reasonable control of Check Point, including,
      without limitation, the performance or availability of Third Party Applications, webpages or internet or other
      services controlled by third parties, an act of God, war (declared or undeclared), revolution, rebellion or civil
      strife, terrorist acts, riots, acts of public enemies, labor strikes or shortages, earthquakes, fires, floods,
      storms, explosions and governmental and regulatory actions (together, sub-sections (i)-(iv), the “Excluded Time”).
    </p>
    <p>
      4.2 <u>Service Latency</u>. Check Point will use commercial reasonable efforts that average monthly latency of the
      Harmony Connect Services during each calendar month will be of 50millisecond or less (“Monthly Service Latency”).
      The latency shall be measured from the time the Harmony Connect enforcement node receives a data packet to the
      time the Harmony Connect enforcement node attempts to deliver the same data packet to the internet, except for
      delay in connection with any Excluded Time. The average Monthly Service Latency will be measured only for the 95%
      of the traffic transferred through the Harmony Connect Service during a calendar month with the lowest latency
      rate.
    </p>
    <p>
      4.3 <u>Service Credits</u>. If notwithstanding Sections 4.1 and 4.2 of these Terms, the Monthly Service
      Availability or the Monthly Service Latency of the applicable Service during a calendar month is below the
      thresholds specified therein, You may request Check Point to extend Your current Service Term by additional days
      (“Service Credits”) at no extra charge as follows, subject to a maximum of 1 month of Service Credits per year of
      Service:
    </p>
    <table className="table table-striped">
      <tbody>
        <tr>
          <td width="264">
            <strong>Monthly Service Availability</strong>
          </td>
          <td width="126">
            <strong>Service</strong>
            <strong> Credits</strong>
          </td>
        </tr>
        <tr>
          <td width="264">Equal to or above 99% and below the applicable threshold in Section 4.1 above</td>
          <td width="126">3 days</td>
        </tr>
        <tr>
          <td width="264">Below 99%</td>
          <td width="126">10 days</td>
        </tr>
      </tbody>
    </table>
    <table className="table table-striped">
      <tbody>
        <tr>
          <td width="264">
            <strong>Monthly Service Latency</strong>
          </td>
          <td width="126">
            <strong>Service Credits</strong>
          </td>
        </tr>
        <tr>
          <td width="264">Equal to or above 50 millisecond and below 100 millisecond</td>
          <td width="126">3 days</td>
        </tr>
        <tr>
          <td width="264">Above 100 millisecond</td>
          <td width="126">10 days</td>
        </tr>
      </tbody>
    </table>
    <p>
      You agree that grant of Service Credits in accordance with this Section 4.3 is Your sole remedy in connection with
      the availability and latency of the Services or a failure by Check Point to comply with Section 4 of these Terms.
      If you have any claims for Service Credits, You may provide Check Point a notice of such claims only within ten
      (10) business days of the end of the applicable calendar month. For the avoidance of doubt, Service Credits are
      non-refundable and may be exercised only by extension of the current Service Term.
    </p>
    <p>
      <strong>5. PRIVACY</strong>
    </p>
    <p>
      5.1 <u>Privacy Policy</u>. You acknowledge and agree that use of Services (and any other Check Point’s products
      and services) is subject to the processing of information (which might contain personal information) pursuant to
      Check Point’s Privacy Policy, which is available at{' '}
      <a href="https://www.checkpoint.com/privacy/" target="_blank" rel="noopener">
        www.checkpoint.com/privacy
      </a>{' '}
      and which is incorporated herein by reference (“Privacy Policy”).
    </p>
    <p>
      5.2 <u>Authorizations</u>. You are responsible to obtain all necessary authorizations, approvals, consents and
      permits per the applicable law (if any) for: (i) providing the data You share with Check Point in connection with
      the Services and/or Your communication with Check Point; and (ii) Check Point’s processing and storing of such
      data in accordance with the Privacy Policy.
    </p>
    <p>
      5.3 <u>DPA</u>. Check Point’s Customers Data Protection Addendum (DPA), which is available at{' '}
      <a href="https://www.checkpoint.com/customersdpa" target="_blank">
        www.checkpoint.com/customersdpa/
      </a>{' '}
      forms an integral part of these Terms and is incorporated herein by reference.
    </p>
    <p>
      <strong>6. TITLE AND INTELLECTUAL PROPERTY</strong>
    </p>
    <p>
      All right, title, and interest in and to the Services, including, without limitation, any technologies, products,
      services and intellectual property rights in connection with the Services, and any improvement or derivative work
      in connection therewith shall remain with Check Point and its licensors. The Services are protected under
      international copyright, trademark and trade secret and patent laws. The license granted herein does not
      constitute a sale of the Services or any portion thereof.
    </p>
    <p>
      <strong>7. TERM AND TERMINATION</strong>
    </p>
    <p>
      These Terms are effective for the Service Term. Check Point may terminate these Terms upon Your breach of any of
      the provisions hereof that is not cured within thirty (30) days. These Terms will terminate immediately without
      notice from Check Point if (i) You fail to comply with any material provision of these Terms, or (ii) Your rights
      to use the Services are expired or terminated for any reason. Upon termination of Your right to use the Services
      under these Terms, You agree to cease all use of the Services, and so certify to Check Point. Except for Your
      rights to use Services and for maintenance and support and as expressly provided herein, the Terms hereunder shall
      survive any termination or expiration.
    </p>
    <p>
      <strong>8. INDEMNIFICATION</strong>
    </p>
    <p>
      8.1 Check Point shall pay all costs, liabilities, damages and other amounts finally awarded against You from an
      action, to the extent based on a third-party claim that Your use of the Services (excluding any Third Party
      Applications) in accordance with these Terms and within the Permitted Scope, directly infringes any US or EU
      patent or trademark issued as of the date of Your Service Order or any copyright or trade secret, provided that
      (i) You promptly notify Check Point of any and all threats, claims or proceedings potentially implicating the
      indemnity obligations set forth in this Section 8.1 and prior to taking any action which could adversely impact
      the defense; and (ii) Check Point is given reasonable assistance and the opportunity to assume sole control over
      the defense of the claims and/or allegations for which indemnity is sought under this Section 8.1 as well as sole
      control over all negotiations for a settlement or compromise of those claims. Check Point will not be responsible
      for any settlement it does not approve in writing in advance and/or for any allegation of trade-secret
      misappropriation, other than one based on an allegedly wrongful act of misappropriation by a Check Point employee
      or agent.
      <br />
      If a Service is, or in Check Point’s opinion is likely to become, the subject of a claim, suit, or proceedings of
      infringement, Check Point may in its sole discretion: (i) procure, at no cost to You, the right to continue using
      such Service; (ii) replace or modify the Service, at no cost to You, to make it non-infringing (even if that
      modification materially impacts the value or utility of the Service), or (iii) terminate the license for the
      infringing Service and grant a refund credit thereon as depreciated on a monthly basis and reflecting the
      remaining Service subscription term.
      <br />
      THE FOREGOING PROVISIONS STATE THE ENTIRE LIABILITY AND OBLIGATIONS OF CHECK POINT WITH RESPECT TO ANY ACTUAL OR
      ALLEGED INFRINGEMENT OF ANY INTELLECTUAL PROPERTY RIGHTS BY THE SERVICES AND IS IN LIEU OF ANY WARRANTIES OF
      NONINFRINGEMENT.
      <br />
      The foregoing indemnity obligation of Check Point does not apply with respect to a Service or portions or
      components thereof: (i) not provided by Check Point, (ii) made in whole or in part in accordance Your
      specifications, (iii) which are modified by anyone other than Check Point, if the alleged infringement relates to
      such modification, (iv) combined with other products, services, processes or materials where the alleged
      infringement relates to such combination, (v) where Check Point could not be held liable for inducing or
      contributing to infringement of Your asserted claims; (vi) with respect to which a claim or allegation of
      infringement was first made prior to the date of Your Service Order; (viii) where the claim arises because of Your
      decision to offer indemnity to a third party that is greater in scope that the indemnity offered herein; or (viii)
      where You continue allegedly infringing activity after being notified thereof or after being informed of
      modifications that would have avoided the alleged infringement. Check Point also shall have no indemnity
      obligation for legal fees, costs or expenses You incurred prior to the time You provide Check Point both (a)
      notice of the claim and (b) materials from which Check Point could reasonably determine that indemnity is owed.
      You will indemnify Check Point and its officers, directors, agents and employees from all damages, settlements,
      attorneys’ fees and expenses related to a claim of infringement or misappropriation excluded from Check Point’s
      indemnity obligation by this Section 8.1.
    </p>
    <p>
      8.2 You agree to defend, indemnify and hold harmless Check Point, its vendors, officers, directors, employees,
      affiliates, subsidiaries, licensors, agents and suppliers from and against any and all claims, damages,
      obligations, losses, liabilities, costs, debts, and expenses (including but not limited to attorney’s fees)
      arising from: (i) Your unauthorized use of the Services; (ii) Your violation of any applicable laws, regulations
      or third party rights, including, without limitation, any intellectual property rights or privacy rights, in
      connection with Your use of the Services and/or instructions provided by You; and (iii) Your breach or violation
      of Your representations to Check Point, of any of these Terms and/or the applicable terms of a Third Party
      Application.
    </p>
    <p>
      <strong>9. LIMITED WARRANTY, WARRANTY DISCLAIMERS AND LIMITATION OF LIABILITY</strong>
    </p>
    <p>
      9.1 <u>Limited Warranty</u>. TO THE FULLEST EXTENT ALLOWED UNDER APPLICABLE LAW, THE SERVICES ARE PROVIDED “AS IS”
      WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED. CHECK POINT DOES NOT WARRANT THAT THE SERVICES WILL
      MEET YOUR REQUIREMENTS OR THAT THEIR OPERATION OR USE WILL BE UNINTERRUPTED OR ERROR FREE. CHECK POINT DISCLAIMS
      ANY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
    </p>
    <p>
      9.2&nbsp;<u>Limitation of Liability</u>. You are solely responsible for adequate protection and backup of the data
      and equipment used in connection with the Services. Check Point does not guarantee that the information accessed
      by the Services will be accurate or complete. You acknowledge that performance of the Services may be affected by
      any number of factors, including without limitation, technical failure of the Services, the acts or omissions of
      third parties and other causes reasonably beyond the control of Check Point. Certain features of a Service may not
      be forward-compatible with future versions of such Service, and use of such features with future versions of such
      Service may require to purchase the applicable future version of the Service. TO THE FULLEST EXTENT ALLOWED UNDER
      APPLICABLE LAW, IN NO EVENT WILL CHECK POINT BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DAMAGES ARISING OUT OF
      THE SUBJECT MATTER OF THESE TERMS AND THE SERVICES UNDER ANY CONTRACT, NEGLIGENCE, STRICT LIABILITY OR OTHER
      THEORY, FOR: (I) ANY INDIRECT, SPECIAL, PUNITIVE, INCIDENTAL, OR CONSEQUENTIAL DAMAGES (INCLUDING LOST PROFITS),
      OR FOR LOSS OF OR CORRUPTION OF DATA, OR FOR COST OF PROCUREMENT OF SUBSTITUTE GOODS OR TECHNOLOGY, IRRESPECTIVE
      OF WHETHER CHECK POINT HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES; AND (II) THE THIRD PARTY APPLICATIONS
      AND YOUR SYSTEMS, INCLUDING, WITHOUT LIMITATIONS THE PERFORMANCE OF THE THIRD PARTY APPLICATIONS AND YOUR SYSTEMS
      AND ANY CONTENT THEREIN. CHECK POINT’S MAXIMUM LIABILITY FOR DAMAGES SHALL BE LIMITED TO THE LICENSE FEE RECEIVED
      BY CHECK POINT FOR THE PARTICULAR SERVICE SUBSCRIPTION LICENSE WHICH CAUSED THE DAMAGES.
    </p>
    <p>
      <strong>10. PRE-RELEASE VERSIONS</strong>
    </p>
    <p>
      10.1&nbsp;<u>License Grant</u>. With respect to any pre-release version of a Service, including a beta, evaluation
      or an early availability product, service or feature (all collectively referred to herein as a “Beta Services”)
      that may be provided to You by Check Point from time to time, at its sole discretion, Check Point grants You a
      non-transferable and non-exclusive license to use the Beta Services for evaluation purposes only. The license is
      designed to provide You with early operational experience with the Beta Services and to provide Check Point with
      specified information regarding Your experiences with the use and operation of the Beta Services. The license
      shall be in effect for a limited period as determined by Check Point and certain other restrictions may apply. You
      may be asked to sign a separate agreement pertaining to the Beta Services.
    </p>
    <p>
      10.2&nbsp;<u>No Obligations</u>. Notwithstanding anything herein to the contrary, Check Point has no obligation to
      provide support, maintenance, upgrades, modifications, or new releases for a Beta Products and Services. Owing to
      the experimental nature of the Beta Services, You are advised not to rely exclusively on the Beta Services for any
      reason. IN NO EVENT WILL CHECK POINT BE LIABLE TO YOU OR ANY OTHER PERSON FOR DAMAGES, DIRECT OR INDIRECT, OF ANY
      NATURE OR EXPENSES INCURRED BY YOU IN CONNECTION WITH THE BETA SERVICES. YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY
      DAMAGES IN CONNECTION WITH THE BETA SERVICES SHALL BE TO TERMINATE THE BETA TEST BY WRITTEN NOTICE TO CHECK POINT.
    </p>
    <p>
      <strong>11. COMPLIANCE WITH LAW</strong>
    </p>
    <p>
      You agree to use the Services only as permitted by and in compliance with any applicable law and regulation in any
      relevant jurisdiction, including, without limitation, laws and regulations regarding export and privacy. You
      warrant and agree that You are not: (i) located in, under the control of, or a national or resident of Cuba, North
      Korea, Iran, Syria, Lebanon, Sudan, the Crimea, the Luhansk People’s Republic (LNR), or the Donetsk People’s
      Republic (DNR) regions of Ukraine, or any other country or region to which the United States and/or the State of
      Israel have prohibited export transactions, or (ii) on the U.S Treasury Department list of Specially Designated
      Nationals or the U.S. Commerce Department’s Denied Persons List.
    </p>
    <p>
      <strong>12. GENERAL</strong>
    </p>
    <p>
      12.1&nbsp;<u>Miscellaneous</u>. You may not assign Your rights or obligations under these Terms without the prior
      written consent of Check Point. If any provision of these Terms is held to be invalid or unenforceable by a court
      of competent jurisdiction, that provision of the Agreement will be enforced to the maximum extent permissible so
      as to affect the intent of the Agreement, and the remainder of the provisions of these Terms shall remain in full
      force and effect. The laws of the State of Israel shall govern all issues arising under or relating to these
      Terms, without giving effect to the conflict of laws principles thereof. All disputes arising under or relating to
      these Terms shall be resolved exclusively in the appropriate Israeli court sitting in Tel Aviv-Yafo district,
      Israel. These Terms will not be governed by the United Nations Convention on Contracts for the International Sales
      of Goods, the application of which is expressly excluded. These Terms sets forth the entire understanding and
      agreement between You and Check Point and may be amended only in writing signed by both parties. Notwithstanding
      the above, in case Check Point approves your Service Order through any of its subsidiaries or billed You via such
      subsidiaries, these Terms shall apply between You and such applicable subsidiary.
    </p>
    <p>
      12.2&nbsp;<u>Third Party Technology</u>. Certain software programs and services provided by third parties (“Third
      Party Technology”) may be provided for use as part of the Services, subject to the licenses of their respective
      proprietors. The provisions of these Terms shall apply to all Third Party Technology and to such third parties
      that have the right to grant licenses for the use of the Third Party Technology (“Third Party Technology
      Providers”) as if they were the Services and Check Point, respectively, unless they are specifically listed and
      addressed at{' '}
      <a href="https://www.checkpoint.com/about-us/third-party-trademarks-and-copyrights/" target="_blank">
        www.checkpoint.com/about-us/third-party-trademarks-and-copyrights/
      </a>
      , in which case, such Third Party Technology Provider’s licenses terms will apply with respect to those specific
      Third Party Technology.
    </p>
    <p>
      12.3&nbsp;<u>Additional Products and Services</u>. You accept and agree that the use and installation of any
      software of Check Point which is not a Service and/or any hardware product of Check Point (collectively,
      “Products”), including, without limitation, those Products connected to or managed through the Infinity Portal
      shall be governed by Check Point’s End-user License Agreement available at{' '}
      <a
        href="https://www.checkpoint.com/support-services/software-license-agreement-limited-hardware-warranty/"
        target="_blank"
        rel="noopener">
        www.checkpoint.com/support-services/software-license-agreement-limited-hardware-warranty/
      </a>
      , which is incorporated herein by reference. You accept and agree that once You connect a Product to Your network,
      device and/or Infinity Portal account, such Product may automatically download and upload certain data, traffic
      and updates, to be used for the installation, operation and configuration of the Product.
    </p>
    <p>
      You accept and agree that the use and installation of any software of Check Point which is not a Service and/or
      any hardware product of Check Point (collectively, “Products”), including, without limitation, those Products
      connected to or managed through the Infinity Portal shall be governed by Check Point’s End-user License Agreement
      available at{' '}
      <a
        href="https://www.checkpoint.com/support-services/software-license-agreement-limited-hardware-warranty/"
        target="_blank"
        rel="noopener">
        www.checkpoint.com/support-services/software-license-agreement-limited-hardware-warranty/
      </a>
      , which is incorporated herein by reference. You accept and agree that once You connect a Product to Your network,
      device and/or Infinity Portal account, such Product may automatically download and upload certain data, traffic
      and updates, to be used for the installation, operation and configuration of the Product.
    </p>
    <p>
      12.4&nbsp;<u>Government Restricted Rights</u>. This provision applies to Services acquired directly or indirectly
      by or on behalf of any government. The Services are commercial services, licensed on the open market at market
      prices. Any use modification, reproduction, release, performance, display, or disclosure of the Services by any
      government shall be governed solely by these Terms and shall be prohibited except to the extent expressly
      permitted by of these Terms, and no license to the Services is granted to any government requiring different
      terms.
    </p>
    <p>
      12.5&nbsp;<u>Feedback</u>. You may provide Check Point feedback or suggestions regarding the Services. Check Point
      will be free to use such feedback and suggestions without any restriction or obligation.
    </p>
    <p>
      12.6 <u>Modifications</u>. You agree that Check Point may revise these Terms at any time. In the event Check Point
      revises these Terms, Check Point will publish a notice containing a link to the revised Terms or upload them to
      its public website. You agree that Your continued use of the Service after such revisions have been made will
      constitute your acceptance of such revised Terms.
    </p>
    <p>
      12.7&nbsp;<u></u>
      <u>Questions?</u> Should You have any questions concerning these Terms, contact Check Point Software Technologies
      Ltd., 5 Shlomo Kaplan Street, Tel Aviv, 67897 Israel.
    </p>
    <p>v.1.13</p>
  </div>
);
